import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SocialChannel } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class SocialChannelsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getSocialChannels() {
    return this.http.get<SocialChannel[]>(`${this.BASE_URL}api/social-channels`);
  }
}
